import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { downloadFile, getLongDate, getStringDate } from 'src/app/common/util';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { VendorService } from 'src/app/services/vendor.service';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-accounting-report',
  templateUrl: './accounting-report.component.html',
  styleUrls: ['./accounting-report.component.scss']
})
export class AccountingReportComponent {
	permissionType = PermissionTypeEnum;
  selectedReport = 0;
  bookReports = [{
    name: 'Libro Diario',
    byMonth: false,
    excel: false,
    pdf: false,
    permissions: [5000, 5006, 2130],
    endPoint: (type: string, report: any) => this.accountingReport.getDailyBook(getLongDate(this.startDate), getLongDate(this.endDate), report.byMonth, type)
  }, {
    name: 'Libro Mayor',
    byMonth: false,
    excel: false,
    pdf: false,
    permissions: [5000, 5006, 2131],
    endPoint: (type: string, report: any) => this.accountingReport.getLedgerBook(getLongDate(this.startDate), getLongDate(this.endDate), report.byMonth, type)
  }, {
    name: 'Libro de Compras',
    excel: false,
    pdf: false,
    permissions: [5000, 5006, 2137],
    endPoint: (type: string, report: any) => this.accountingReport.getPurchasesBook(getLongDate(this.startDate), getLongDate(this.endDate), type)
  }, {
    name: 'Libro de Ventas',
    excel: false,
    pdf: false,
    permissions: [5000, 5006, 2138],
    endPoint: (type: string, report: any) => this.accountingReport.getSalesBook(getLongDate(this.startDate), getLongDate(this.endDate), type)
  }]
  balanceReports = [{
    name: 'Balance de Saldos',
    level: 3,
    excel: false,
    pdf: false,
    permissions: [5000, 5006, 2133],
    endPoint: (type: string, report: any) => this.accountingReport.getBalanceBook(getLongDate(this.endDate), report.level, type)
  }, {
    name: 'Balance General',
    excel: false,
    pdf: false,
    permissions: [5000, 5006, 2134],
    endPoint: (type: string, report: any) => this.accountingReport.getGeneralBalanceBook(getLongDate(this.endDate), type)
  }]
  otherBooks = [{
    name: 'Estado de Resultados',
    excel: false,
    pdf: false,
    permissions: [5000, 5006, 2132],
    endPoint: (type: string, report: any) => this.accountingReport.getIncomeBook(getLongDate(this.startDate), getLongDate(this.endDate), type)
  }, {
    name: 'Estado de Flujos de Efectivo',
    excel: false,
    pdf: false,
    permissions: [5000, 5006, 2135],
    endPoint: (type: string, report: any) => this.accountingReport.getCashflowBook(getLongDate(this.endDate), type)
  }, {
    name: 'Notas a los Estados Financieros',
    pdf: false,
    permissions: [5000, 5006, 2136],
    endPoint: (type: string, report: any) => this.accountingReport.getNotesBook(getLongDate(this.endDate), type)
  }, {
    name: 'Conjunto Completo de Estados Financieros',
    pdf: false,
    permissions: [5000, 5006, 2139],
    endPoint: (type: string, report: any) => this.accountingReport.getAccountingBookAll(getLongDate(this.endDate), type)
  }]


  startDate = "";
  endDate = "";
  client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  clients = [];
  filterClients = [];
  clientSelected = null;
  timeout = null;

  constructor(
    private toastService: ToastrService,
    private accountingReport: AccountingReportService,
    private vendorService: VendorService
  ) {
    const today = new Date();
    this.endDate = getStringDate(today);
    today.setDate(today.getDate() - 30);
    this.startDate = getStringDate(today);
    this.getInitVendors();
  }

  getInitVendors(){
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.clients = clientsData;
        this.client.filterElements = clientsData;
        this.client.class = "fa-list";
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    }); 
  }

  selectClient(client: any, status: number) {
    this.client.value = `${client.name} - ${client.nit}`;
    this.client.class = "fa-check";
    this.client.required = false;
    this.filterClients = this.clients;
    this.clientSelected = client;
  }

  writeClient() {
    clearTimeout(this.timeout);
    this.client.class = "typing";

    this.timeout = setTimeout(() => {
      this.client.class = "loading";

      const clue = this.client.value;

      forkJoin([
        this.vendorService.getProvidesByClue(clue),
        this.vendorService.getClientsByClue(clue)
      ]).subscribe({
        next: ([providersResponse, clientsResponse]: [ResponseObject, ResponseObject]) => {
          // Combinar sin duplicados por ID
          const all = [...providersResponse.data, ...clientsResponse.data];

          // Eliminar duplicados por ID
          const uniqueById = all.filter(
            (value, index, self) =>
              index === self.findIndex((v) => v.id === value.id)
          );

          this.client.filterElements = uniqueById;

          if (uniqueById.length === 0) {
            this.client.class = "fa-xmark";
            this.client.required = true;
          } else {
            this.client.class = "fa-filter";
          }
        },
        error: (error: any) => {
          this.client.required = true;
          this.client.class = "fa-xmark";
          this.toastService.error("Error al obtener clientes/proveedores con el valor " + this.client.value);
        }
      });
    }, 500);
  }


  getBook(type: string, report: any) {
    this.loadAnimation(report, type, true);
    report.endPoint(type, report).subscribe({
      next: (response: ResponseObject) => {
        this.downloadHandlerResponse(response.data, type, report);
      },
      error: (error: HttpErrorResponse) => {
        this.errorHandlerResponse(error, report, type);
      }
    })
  }

  getBalance(type: string, report: any) {
    this.loadAnimation(report, type, true);
    report.endPoint(type, report).subscribe({
      next: (response: ResponseObject) => {
        this.downloadHandlerResponse(response.data, type, report);
      },
      error: (error: HttpErrorResponse) => {
        this.errorHandlerResponse(error, report, type);
      }
    })
  }

  errorHandlerResponse(error: HttpErrorResponse, report: any, type: string) {
    if (error.status == 400) {
      this.toastService.error(error.error.message);
    } else {
      this.toastService.error("Error al descargar el reporte de " + report.name);
    }
    this.loadAnimation(report, type, false);
  }

  downloadHandlerResponse(text: string, type: string, report: any) {
    downloadFile(text, type, report.name);
    this.toastService.success("Se ha descargado el reporte de " + report.name);
    this.loadAnimation(report, type, false);
  }

  loadAnimation(report: any, type: string, isLoading: boolean) {
    if (type == 'excel') {
      report.excel = isLoading;
    } else if (type == 'pdf') {
      report.pdf = isLoading;
    }
  }
}
